import { GoogleMapsProvider } from "./components/GoogleMapsProvider";
import { SectionBubble } from "./components/section-bubble";
import { BlogCarousel } from "./components/blog-carousel";
import { Ads } from "./components/ads";
import { createStore } from "solid-js/store";
import { fetchGet } from "./components/universal/common";
import { CMS } from "./components/cms/cms";
import { CMSBlock, CMSProvider } from "./components/cms/provider";
import { onMount, Show } from "solid-js";
import { BirthsDeaths } from "./components/births-deaths";
import { RecentAdditions } from "./components/recent-notifications";

export const [cms, setCms] = createStore<Record<string,CMSBlock>>({});
export const loadCms = async (ids: string[]) => {
    const cachedIds = Object.keys(cms);
    const uncachedIds = ids.filter(id => !cachedIds.some(key => key == id));
    if (!uncachedIds.length) return;
    let json: any;
    try {
        const res = await fetchGet("/Home/GetContentBlocksJson", { ids: uncachedIds.join(",") });
        json = await res.json();
        if (!json.Success) return;
    } catch (ex) {
        console.log("loadCms", { ex });
        return;
    }
    let data: Record<string, CMSBlock> = {};
    uncachedIds.forEach(id => {
        let value = json.Data[id];
        if (!value || value.length === 0) {
            data[id] = { found: false, item: null };
            return;
        }
        data[id] = { found: true, item: value };
    });
    setCms(data);
}

type State = {
    isContentReady: boolean;
};

function App() {
    const [state, setState] = createStore<State>(
        { isContentReady: false }
    );
    onMount(async () => {
        await loadCms([
            "homepage::museum",
            "homepage::news",
            "homepage::education",
            "homepage::aboutus",
            "homepage::competitions",
            "homepage::store"        
        ]);
        setState("isContentReady", true);
    });
    return (
        <Show when={state.isContentReady}>
            <GoogleMapsProvider apiKey="AIzaSyAweLj0DgOj1Em6hgX0-yPuOmwlvXLCJ2c">
                <CMSProvider cms={cms} setCms={setCms}>
                    <section class="landing-page">
                        <div class="container home-page m-t-xxl">
                            <Ads />
                            <hr class="featurette-divider" style="margin-top: 40px;" />
                            <div style="margin-top: 40px;">
                                <h4 style="font-size: 2em; font-family: 'Oswald'; color: #999;">
                                    Most Recent Blog
                                </h4>
                                <BlogCarousel />
                            </div>
                            <hr class="featurette-divider" style="margin-top: 20px;" />
                            <div class="row">
                                <div class="col-md-9" id="landing-page-circles">
                                    <div class="row salon-home">
                                        <div class="col-md-4 col-sm-6 wow fadeInLeft animated">
                                            <SectionBubble name="Museum" url="/Museum/Home" imageUrl={"/Media/Elements/homepage-museum.jpg"}>
                                                <CMS id="homepage::museum">
                                                    The ARC Museum is the largest online museum dedicated completely to realist art work. It contains tens of thousands of images by thousands of artists and includes works by 19th century and old master artists through our general search pages, as well as 21st century realist works by our ARC Affiliated ArtistsSM.
                                                </CMS>
                                            </SectionBubble>
                                        </div>
                                        <div class="col-md-4 col-sm-6">
                                            <SectionBubble name="News" url="/News/Home" imageUrl={"/Media/Elements/homepage-news.jpg"}>
                                                <CMS id="homepage::news">Our news section consists of two parts, the first being our News Blog where we post daily to keep our viewers informed on relevant topics about realist art and the second is our Events Calendar which is an interactive calendar listing of all the exciting realist art events taking place around the world including: exhibitions, lectures, open houses, competitions, artist demonstrations, video and podcast releases, publication releases, enrollment dates and more. The calendar can also be viewed in three ways, as a calendar, a general listing, or as a world map.</CMS>
                                            </SectionBubble>
                                        </div>
                                        <div class="col-md-4 col-sm-6 wow fadeInRight animated">
                                            <SectionBubble name="Education" url="/Education/Home" imageUrl={"/Media/Elements/homepage-education.jpg"}>
                                                <CMS id="homepage::education">As a non-profit educational foundation, education is one of our primary goals. Here is where you can find our ARC ApprovedR School listing, ARChives where we have our articles, letters and more, The Da Vinci Initiative which focuses on skill-based learning in K-12 classrooms, artist interviews, artist demonstrations, podcasts, self help books and more.</CMS>
                                            </SectionBubble>
                                        </div>
                                    </div>
                                    <div class="row salon-home m-t-xxl">
                                        <div class="col-md-4 col-sm-6">
                                            <SectionBubble name="About Us" url="/AboutUs/Home" imageUrl={"/Media/Elements/home-page-about-us.jpg"}>
                                                <CMS id="homepage::aboutus">Find out more about the ARC and its staff. Learn about our mission and ARC philosophy. Find information on ARC Allied Organizations and how to contact us.</CMS>
                                            </SectionBubble>
                                        </div>
                                        <div class="col-md-4 col-sm-6">
                                            <SectionBubble name="Competitions" url="/Competition/Home" imageUrl={"/Media/Salon/Results/11th.jpg"}>
                                                <CMS id="homepage::competitions">View the results of past and current ARC competitions or submit your entries here. The ARC holds two types of competitions. The ARC Scholarship Competition, held every May, gives thousands of dollars in direct financial aid to students attending ARC ApprovedR Schools. The International ARC Salon, the most prestigious realist art competition in the Americas and perhaps the world, offers over $100,000 in cash awards and International recognition through partnerships with prestigious magazines, galleries, museum exhibitions, and a strong online presence.</CMS>
                                            </SectionBubble>
                                        </div>
                                        <div class="col-md-4 col-sm-6">
                                            <SectionBubble name="Store" url="/Store/Home" imageUrl={"/Media/Elements/home-page-store.jpg"}>
                                                <CMS id="homepage::store">Help support the ARC by purchasing fine art prints, books, DVDs, or more. Here you will also find information on image usage and advertising rates.</CMS>
                                            </SectionBubble>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div style="margin-top: 30px;">
                                        <BirthsDeaths />
                                        <RecentAdditions />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </CMSProvider>
            </GoogleMapsProvider>
        </Show>
    );
}
export default App;